<template>
  <v-container fluid class="skill-create">
    <v-row>
      <v-col class="custom-content-container pt-0" cols="12">
        <v-row>
          <v-col md="12">
            <v-card flat class="custom-grey-border remove-border-radius">
              <v-simple-table
                class="inner-simple-table custom-border-top certs-table"
                fixed-header
              >
                <template v-slot:default>
                  <thead
                    style="
                      background-color: rgb(243, 246, 249);
                      color: rgb(36, 50, 109);
                    "
                  >
                    <tr class="custom-border-bottom">
                      <td
                        class="font-size-16 font-weight-700"
                        style="width: 45%"
                      >
                        Leave Type
                      </td>
                      <td
                        class="font-size-16 font-weight-700"
                        style="width: 40%"
                      >
                        Allocated Leaves
                      </td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="groupLeaves.length > 0">
                      <tr
                        v-for="(row, index) in groupLeaves"
                        :key="row.leave_type_id"
                        :class="{ 'orange_lighten-5': index % 2 === 0 }"
                      >
                        <td>
                          <v-text-field
                            dense
                            filled
                            readonly
                            solo
                            v-model="row.leave_title"
                            flat
                            class="mt-0 py-0"
                          />
                        </td>
                        <td>
                          <!-- :rules="[
                              validateRules.minLength(
                                  row.allocated_leave,
                                  'Allocated Leave',
                                  row.min_leave
                                ),
                                validateRules.maxLength(
                               row.allocated_leave,
                                  'Allocated Leave',
                                  row.max_leave
                                ),
                            ]" -->
                          <v-text-field
                            dense
                            filled
                            placeholder="Allocated Leave"
                            solo
                            v-model.number="row.allocated_leave"
                            type="number"
                            flat
                            color="cyan"
                            class="mt-0 py-0"
                            @input="updateLeaves"
                            v-on:keyup="checkAllocationLimit(row)"
                          />
                        </td>
                        <td>
                          <span
                            ><em class="font-weight-700 font-size-lg"
                              >days</em
                            ></span
                          >
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td :colspan="3" class="text-center">
                          <p
                            class="m-0 row-not-found font-weight-500 font-size-16"
                          >
                            Sorry! No Leaves Found.
                          </p>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import { EngineerEventBus } from "@/core/lib/engineer/engineer.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { ErrorEventBus } from "@/core/lib/message.lib";

export default {
  name: "engineer-leaves",
  mixins: [ValidationMixin, CommonMixin],
  props: {
    pageLoading: {
      type: Boolean,
      default: false,
    },
    updateEngineer: {
      type: Boolean,
      default: false,
    },
    leavesArr: {
      type: Array,
      default: () => [],
    },
    engineer: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      timeoutLimit: 500,
      timeout: null,
      groupLeaves: [],
    };
  },
  watch: {
    leavesArr: {
      immediate: true,
      handler() {
        this.initializeLeaves();
      },
    },
    engineer: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.leaves) {
          this.setEngineerLeaves();
        }
      },
    },
  },
  methods: {
    initializeLeaves() {
      const existingLeaves = this.engineer?.leaves || [];
      const leavesMap = existingLeaves.reduce((acc, leave) => {
        acc[leave.leave] = leave.leave_allowed;
        return acc;
      }, {});

      this.groupLeaves = this.leavesArr.map((leave) => ({
        leave_type_id: leave.id,
        leave_title: leave.name,
        allocated_leave: leavesMap[leave.id] || 0,
        min_leave: leave.min_leave,
        max_leave: leave.max_leave,
      }));
      this.emitLeavesUpdate();
    },
    setEngineerLeaves() {
      if (!this.lodash.isEmpty(this.engineer.leaves)) {
        const engineerLeavesMap = this.engineer.leaves.reduce((acc, leave) => {
          acc[leave.leave] = leave.leave_allowed;
          return acc;
        }, {});

        this.groupLeaves = this.leavesArr.map((leave) => ({
          leave_type_id: leave.id,
          leave_title: leave.name,
          allocated_leave: engineerLeavesMap[leave.id] || 0,
          min_leave: leave.min_leave,
          max_leave: leave.max_leave,
        }));
      } else {
        this.initializeLeaves();
      }
      this.emitLeavesUpdate();
    },
    updateLeaves() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.emitLeavesUpdate();
      }, this.timeoutLimit);
    },
    emitLeavesUpdate() {
      const allLeaves = this.leavesArr.map((leaveType) => {
        const existing = this.groupLeaves.find(
          (l) => l.leave_type_id === leaveType.id
        );
        return {
          leave_type_id: leaveType.id,
          leave_title: leaveType.name,
          allocated_leave: existing ? existing.allocated_leave : 0,
          min_leave: existing.min_leave,
          max_leave: existing.max_leave,
        };
      });

      EngineerEventBus.$emit("update:engineer-leaves", allLeaves);
    },
    checkAllocationLimit(row) {
      if (row.allocated_leave === null || row.allocated_leave === undefined) {
        ErrorEventBus.$emit(
          "update:error",
          " Please enter allocated leave for " + row.leave_title
        );
        return;
      }
      let validationTimeout;

      clearTimeout(validationTimeout);
      validationTimeout = setTimeout(() => {
        if (
          Number(row.allocated_leave) < Number(row.min_leave) ||
          Number(row.allocated_leave) > Number(row.max_leave)
        ) {
          ErrorEventBus.$emit(
            "update:error",
            " Please enter allocated leave between " +
              row.min_leave +
              " and " +
              row.max_leave +
              " days for " +
              row.leave_title
          );
          return (row.allocated_leave = row.min_leave);
        }
      }, 1000);
    },
  },
  mounted() {
    this.setEngineerLeaves();
  },
};
</script>

<style scoped>
.certs-table td {
  border-bottom: thin solid rgba(0, 0, 0, 0.06) !important;
}
</style>
